import Experiment from '@mc/experiments-react'
import {
  CMHeroSectionSubsExp,
  getCmHeroPrices,
  HeroVariant1,
  type HeroVariantProps,
} from 'pages/certificates/experiments/mccerts-2548_v1-subscriptions-entry-point'
import { TrackingAttributes } from 'pages/certificates/tracking'
import { MCCERTS_2972_SUBS_ONLY_CLP_FLAG } from './constants'
import { useSubsOnlyClpExpBucket } from './utils/useIsSubsOnlyClpExpActive'
import { HeroVariantPassOnly } from './variant_1/HeroVariantPassOnly'
import { HeroVariantPassOnlyMonthly } from './variant_2/HeroVariantPassOnlyMonthly'
import { HeroVariantPassOnlyNoPrice } from './variant_3/HeroVariantPassOnlyNoPrice'

export const CMHeroSectionSubsOnlyExp = (props: HeroVariantProps) => {
  const bucket = useSubsOnlyClpExpBucket(props)
  if (!bucket) {
    return <CMHeroSectionSubsExp {...props} />
  }

  const { subscriptionPrice } = getCmHeroPrices(
    props.product,
    props.subscriptionOffer,
  )

  return (
    <TrackingAttributes
      hero_state={subscriptionPrice.originalPrice ? 'promo' : 'default'}
      variant={bucket}
    >
      {/* track={false}: the page-level TrackExperimentViewed owns the exposure */}
      <Experiment<HeroVariantProps>
        {...props}
        name={MCCERTS_2972_SUBS_ONLY_CLP_FLAG}
        track={false}
        default={HeroVariant1}
        variant_1={HeroVariantPassOnly}
        variant_2={HeroVariantPassOnlyMonthly}
        variant_3={HeroVariantPassOnlyNoPrice}
      />
    </TrackingAttributes>
  )
}
